;(function () {
  'use strict'

  var memoizedFileExtensions = {}
  var memoizedMimeTypes = {}

  function getDataForContentType(contentType, memo, callback) {
    if (memo[contentType]) return memo[contentType]

    var data = []
    var pattern = new RegExp(contentType, 'i')

    for (var category in this) {
      if (typeof category === 'function') continue
      if (!pattern.test(category)) continue

      data.push(callback(this[category]))
    }
    memo[contentType] = _.uniq(_.flatten(data))

    return memo[contentType]
  }

  // @note Category is 'basicAudio', 'complexAudio', etc. Content type is
  //   'audio', 'image', etc. Basic means the browser probably has support;
  //   complex means the browser will probably need a plugin or library.
  var Filetypes = {
    // @see https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats#Browser_compatibility
    basicAudio: {
      mp3: ['audio/mp3', 'audio/MPA', 'audio/mpa-robust', 'audio/mpeg'],
      // @see https://wiki.xiph.org/MIME_Types_and_File_Extensions
      // @see https://en.wikipedia.org/wiki/HTML5_video#Supported_video_and_audio_formats
      oga: ['audio/ogg'],
      ogg: ['audio/ogg'],
      // @see https://en.wikipedia.org/w/index.php?title=Pulse-code_modulation&oldid=787569806
      wav: [
        'audio/L8',
        'audio/L16',
        'audio/L20',
        'audio/L24',
        'audio/wav',
        'audio/vnd-wave',
        'audio/x-wav',
      ],
    },
    complexAudio: {
      aiff: [
        'audio/L8',
        'audio/L16',
        'audio/L20',
        'audio/L24',
        'audio/wav',
        'audio/vnd-wave',
        'audio/x-wav',
      ],
      au: [
        'audio/L8',
        'audio/L16',
        'audio/L20',
        'audio/L24',
        'audio/wav',
        'audio/vnd-wave',
        'audio/x-wav',
      ],
      // @see https://wiki.xiph.org/MIME_Types_and_File_Extensions
      flac: ['audio/flac'],
      pcm: [
        'audio/L8',
        'audio/L16',
        'audio/L20',
        'audio/L24',
        'audio/wav',
        'audio/vnd-wave',
        'audio/x-wav',
      ],
      l16: ['audio/L16'],
      wma: ['application/vnd.ms-asf', 'video/x-ms-asf', 'video/x-ms-wma'],
    },

    // @see https://en.wikipedia.org/wiki/Portable_Executable
    // @see https://github.com/sindresorhus/file-type/blob/7c860fda6dc379a774e52fc5de56355712e6078e/index.js#L455-L460
    basicBlacklist: {
      acm: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      ax: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      cpl: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      dll: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      drv: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      efi: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      exe: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      mui: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      ocx: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      scr: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      sys: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      tsp: [
        'application/vnd.microsoft.portable-executable',
        'application/x-msdownload',
      ],
      msg: ['text/msg'],
    },

    basicDocument: {
      pdf: ['application/pdf', 'application/x-pdf'],
      rtf: ['application/rtf', 'application/x-rtf', 'text/rtf'],
      txt: ['text/plain', 'text/*'],
    },
    // @see https://stackoverflow.com/a/4212908/672403
    complexDocument: {
      doc: ['application/msword'],
      docx: [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ],
      md: ['text/markdown'],
      pptx: [
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      ],
      xlsx: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
    },

    // @see https://en.wikipedia.org/wiki/Comparison_of_web_browsers#Image_format_support
    basicImage: {
      bmp: ['image/bmp', 'image/x-windows-bmp'],
      gif: ['image/gif'],
      jpeg: ['image/jpeg'],
      jpg: ['image/jpeg'],
      png: ['image/png'],
      svg: ['image/svg+xml'],
      webp: ['image/webp'],
    },
    // These can generally be handled by the image CDN.
    complexImage: {
      ai: ['application/illustrator', 'application/postscript'],
      eps: ['application/eps', 'application/x-eps', 'image/eps', 'image/x-eps'],
      pdf: ['application/pdf', 'application/x-pdf'],
      psd: [
        'application/photoshop',
        'application/psd',
        'application/x-photoshop',
        'image/vnd.adobe.photoshop',
      ],
      ps: ['application/postscript'],
      tiff: ['image/tiff'],
      webp: ['image/webp'],
    },

    basicVideo: {
      gifv: ['video/mp4'],
      m4p: ['video/m4v', 'video/mp4', 'video/x-m4v'],
      m4v: ['video/m4v', 'video/mp4', 'video/x-m4v'],
      mov: ['video/quicktime'],
      mp4: [
        'application/mp4',
        'video/h264',
        'video/H264',
        'video/H264-SVC',
        'video/mpeg4',
        'video/mpeg4-generic',
        'video/mp4',
        'video/quicktime',
      ],
    },
    // @see http://www.serverintellect.com/support/iis/mime-types/
    complexVideo: {
      '3g2': ['video/3gpp2'],
      '3gpp2': ['video/3gpp2'],
      '3gp': ['video/3gp', 'video/3gpp', 'video/3gpp-tt'],
      '3gpp': ['video/3gp', 'video/3gpp', 'video/3gpp-tt'],
      asf: [
        'application/vnd.ms-asf',
        'video/x-la-asf',
        'video/x-ms-asf',
        'video/x-ms-wmv',
      ],
      avi: ['video/avi', 'video/msvideo', 'video/x-msvideo'],
      flv: ['video/flv', 'video/x-flv'],
      hevc: ['video/H265'],
      m2v: ['video/mpeg'],
      mj2: ['video/JPEG', 'video/jpeg2000', 'video/mj2', 'video/x-motion-jpeg'],
      mjp2: [
        'video/JPEG',
        'video/jpeg2000',
        'video/mj2',
        'video/x-motion-jpeg',
      ],
      mkv: ['application/x-matroska', 'video/mkv', 'video/x-matroska'],
      movie: ['video/x-sgi-movie'],
      m2p: ['video/mpeg', 'video/MP1S', 'video/MP2P', 'video/mpeg-2'],
      mp2: ['video/mpeg', 'video/MP1S', 'video/MP2P', 'video/mpeg-2'],
      mpe: ['video/mpeg'],
      mpeg: ['video/mpeg'],
      mpg: ['video/mpeg'],
      mpv: ['video/mpv'],
      mv: ['video/x-sgi-movie'],
      mxf: ['application/mxf'],
      ogg: ['application/ogg', 'video/ogg', 'video/ogm'],
      ogv: ['video/ogg'],
      qt: ['video/quicktime'],
      // Do people actually upload RTP videos? Or did we just start with a list
      // that included tons of RTP MIME types?
      rtp: [
        'video/1d-interleaved-parityfec',
        'video/BMPEG',
        'video/BT656',
        'video/CelB',
        'video/DV',
        'video/encaprtp',
        'video/H261',
        'video/H263',
        'video/H263-1998',
        'video/H263-2000',
        'video/H264-RCDO',
        'video/mp4v-es',
        'video/MP4V-ES',
        'video/MPV',
        'video/nv',
        'video/pointer',
        'video/raptorfec',
        'video/rtp-enc-aescm128',
        'video/rtploopback',
        'video/rtx',
        'video/SMPTE292M',
        'video/ulpfec',
      ],
      ts: ['video/MP2T'],
      vc1: ['video/vc1'],
      vob: ['video/mpeg'],
      vp8: ['video/VP8'],
      webm: ['video/webm'],
      wmv: [
        'application/vnd.ms-asf',
        'video/x-ms-asf',
        'video/x-ms-wmv',
        'video/x-ms-wm',
        'video/x-ms-wmx',
        'video/x-ms-wvx',
        'video/x-msvideo',
      ],
    },

    getMimeTypesForContentType: function (contentType) {
      var callback = function (category) {
        return Object.values(category)
      }
      return getDataForContentType.call(
        this,
        contentType,
        memoizedMimeTypes,
        callback
      )
    },

    getFileExtensionsForContentType: function (contentType) {
      var callback = function (category) {
        return Object.keys(category)
      }
      return getDataForContentType.call(
        this,
        contentType,
        memoizedFileExtensions,
        callback
      )
    },

    findCategoryByFileExtension: function (fileExtension) {
      var sanitized = fileExtension.toLowerCase()

      for (var category in this) {
        if (typeof category === 'function') continue

        if (Object.keys(this[category]).includes(sanitized)) return category
      }
      return null
    },
  }
  window.Filetypes = Filetypes
})()
